// https://restcountries.com/v3.1/all

import { baseSplitApi } from "./baseApi";

const basePath = 'https://countriesnow.space/api/v0.1/countries/info?returns=currency,flag,unicodeFlag,dialCode'

const countries = 'Countries'

export const countriesApi = baseSplitApi.injectEndpoints({
  endpoints: (build) => ({
    
    getAllCountries: build.query({
      query: () => {
        return {
          url: `${basePath}`,
          method: 'GET'
        }
      },
      keepUnusedDataFor: 30,
      providesTags: [countries],
      transformResponse: response => response.data
    }),
  }),
  overrideExisting: false,
})



export const { useGetAllCountriesQuery } = countriesApi